<template>
    <modal dialog="modal-x-sm" class="fluid narrow">
        <div slot="title">New note</div>

        <div slot="body">
            <div class="wrapper fs-normal">
                <textarea autofocus v-model="form.note" rows="8" placeholder="What's on your mind?"></textarea>
            </div>
        </div>

        <div slot="footer" v-if="types" class="d-flex flex-all">
            <button type="button" class="btn yes wide my-3 w-100" @click="save" :disabled="getIsUpdatingEventNote">Save</button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data: function() {
            return {
                form: {
                    type: 2
                },
                selectedType: null
            }
        },
        created: function() {
            if (this.getSelectedNote) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedNote));
            }
        },
        asyncComputed: {
            async types() {
                let vm = this;
                try {
                    let response = await axios.get('/api/settings/GetNoteVisibilityList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        console.log('type: '+vm.form.type);
                        if (this.form.type) {
                            console.log('here');
                            this.selectedType = response.data.find(item => item.id === this.form.type);
                        }
                        else {
                            console.log('here2');
                            this.selectedType = response.data[0];
                            this.form.type = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        computed: {
            ...mapGetters([
                'account',
                'getSelectedEvent',
                'getSelectedNote',
                'getIsUpdatingEventNote'
            ])
        },
        methods: {
            ...mapActions([
                'addEventNote',
                'updateEventNote',
            ]),
            updateType: function() {
                this.form.type = this.selectedType.id || null;
            },
            save: function() {
                this.form.eventId = this.getSelectedEvent.id;

                if(this.getSelectedNote) {
                    this.updateEventNote({
                        action: 'edit',
                        fields: {
                            supplierId: this.account.supplierId,
                            eventNote: this.form
                        }
                    });
                }
                else {
                    this.addEventNote({
                        action: 'create',
                        fields: {
                            supplierId: this.account.supplierId,
                            eventNote: this.form
                        }
                    });
                }
            }
        },
        components: {
            Modal,
            VSelect: extendedVSelect
        }
    }
</script>



// WEBPACK FOOTER //
// NoteAdd.vue?77223671